import React from 'react';
import Countdown from 'react-countdown';
import axios from 'axios';

import Navbar from '../components/TopNav';
import Footer from '../components/Footer';

import monos from '../images/accumulation/monos.png';
import tick from '../images/accumulation/tick.png';
const Accumulations = () => {
  
  const array = [
    {percent: '20%', amount: '1,500.23', claim: 'claimed'},
    {percent: '10%', amount: '1,200.23', claim: 'available'},
    {percent: '10%', amount: '920.23', claim: 'unavailable'},
    {percent: '20%', amount: '1,500.23', claim: 'unavailable'},
    {percent: '20%', amount: '1,500.23', claim: 'unavailable'},
    {percent: '15%', amount: '1,200.23', claim: 'unavailable'},
  ]
  const renderer = ({ days,hours, minutes, seconds, completed }) => {
      const day = days.toString().length === 1 ? 0 : ''
      const hour = hours.toString().length === 1 ? 0 : ''
      const min = minutes.toString().length === 1 ? 0 : ''
      const sec = seconds.toString().length === 1 ? 0 : ''
      return (
        <p className="time-p">
         <span className="time">{day}{days}</span> : <span className="time">{hour}{hours}</span> : <span className="time">{min}{minutes}</span> : <span className="time">{sec}{seconds}</span>
        </p>
      );
  };
  return (
    <div className="row no-gutters accumulation">
      <Navbar />
      <div className="col-12 main">
        <h5>YOUR ACCUMULATIONS</h5>
        <table className="table">
          <thead>
            <tr className="top-tr">
              <th>%</th>
              <th>AMOUNT ($MONS)</th>
              <th>TIME LEFT</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody className="hide">
            {array.map(arr=> (
              <tr className={`${arr.claim === 'claimed' ? 'claim-tr': 'tr'}`}>
                <td className={`${arr.claim === 'claimed' ? 'claim-td-left': 'td-left'}`}>{arr.percent}</td>
                <td><img src={monos} alt=""/> {arr.amount}</td>
                <td>{arr.claim === 'claimed' && <img src={tick} alt=""/>} {arr.claim === 'claimed' ? 'CLAIMED': arr.claim === 'available' ? 'AVAILABLE' :
                 <Countdown renderer={renderer}
                 date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} /> }</td>
                <td className={`${arr.claim === 'claimed' ? 'claim-td-right': 'td-right'}`}><button disabled={arr.claim === 'unavailable'} 
                className={`${arr.claim === 'claimed' ? 'claim-btn': '' } btn buy`}>
                  {arr.claim === 'claimed'? 'CLAIMED': 'Claim Now'}
                  </button></td>
              </tr>
            ))} 
          </tbody>
        </table>
        <div className="mobile-view hide">
          {array.map(arr => (
            <div className={`${arr.claim === 'claimed' ? 'first-box': 'sec-box'} box`}>
              <div>
              <p>{arr.percent}</p>
              {arr.claim === 'claimed' ? <p><img src={tick} alt=""/> CLAIMED</p>: arr.claim === 'available' ? <p>AVAILABLE</p> :
                 <Countdown renderer={renderer}
                 date={new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 2,  0, 23, 59, 50, 100).getTime()} /> }
              </div>
              <div>
                <p><img src={monos} alt=""/> {arr.amount}</p>
                <button disabled={arr.claim === 'unavailable'} 
                className={`${arr.claim === 'claimed' ? 'claim-btn': '' } btn buy`}>
                  {arr.claim === 'claimed'? 'CLAIMED': 'Claim Now'}
                  </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
     </div>
  )
}

export default Accumulations;